import React from "react";
import RadioButtons from "../../RadioButtons";

const options = [
  { value: "all", label: I18n.t("all") },
  { value: "preliminary", label: I18n.t("preliminary") },
  { value: "reviewed", label: I18n.t("reviewed") }
];

export default function ResultStateInput({ value, onChange }) {
  const handleChange = option => onChange(option.value);
  return (
    <RadioButtons
      name="result_state"
      onChange={dropDownItem => handleChange(dropDownItem)}
      options={options}
      value={value}
    />
  );
}
